/**
 * @generated SignedSource<<03bf71a44087e91940c0f126b246ade6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchProductPreview_StoreProduct$data = {
  readonly id: string;
  readonly imageUrl: string | null;
  readonly name: string | null;
  readonly partNumber: string | null;
  readonly " $fragmentType": "ProductExpireBatchProductPreview_StoreProduct";
};
export type ProductExpireBatchProductPreview_StoreProduct$key = {
  readonly " $data"?: ProductExpireBatchProductPreview_StoreProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchProductPreview_StoreProduct">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductExpireBatchProductPreview_StoreProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "5196b89cf8c7917dd9a4f7a72c40281e";

export default node;
